import HTTP from '../helper/http';

const NotificationModel =
{
    
    createNotification: async function(formData)
    {
        var url = 'https://admin.pup.a2hosted.com/notification/createNotification';

        var postData = new FormData();
        Object.keys(formData)?.map(key => 
        {
            return formData[key] !== '' ? postData.append(key, formData[key]) : null ;
        });

        return await HTTP.post(url, postData).then(response =>{return response;})
    }
}

export default NotificationModel;